import { render, staticRenderFns } from "./PartnerKey.vue?vue&type=template&id=4bad1185&scoped=true&"
import script from "./PartnerKey.vue?vue&type=script&lang=js&"
export * from "./PartnerKey.vue?vue&type=script&lang=js&"
import style0 from "./PartnerKey.vue?vue&type=style&index=0&id=4bad1185&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bad1185",
  null
  
)

export default component.exports